import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Store } from 'src/app/core/store/store';
// import { FeedbackService } from '../../models/feedback.service';
import { User } from '../../models/user.model';
import { EventsService } from '../../services/events.service';
import { FeedbackService } from '../../services/feedback.service';
import { UtilityService } from '../../utils/utility.service';

@Component({
  selector: 'app-question-video-feedback',
  templateUrl: './question-video-feedback.component.html',
  styleUrls: ['./question-video-feedback.component.css']
})
export class QuestionVideoFeedbackComponent implements OnInit {

  @Input() data;
  @Input() updateData;
  showCommentBox = false;
  mode = 'new';
  user;
  @Output() feedbackResponse = new EventEmitter<any>();
  content = false;
  platform = false;
  review = false;
  comment = '';

  categoryOptions = [
    {
      name: 'Content',
      description: 'Difficulty understanding concept, unclear instructions.',
      isSelected: false
    },
    {
      name: 'Platform',
      description: 'Video or audio unclear, errors in platform interaction.',
      isSelected: false
    },
    {
      name: 'Others',
      description: 'My issue is not listed here.',
      isSelected: false
    }];
  activation: any;
  @Input() allData;

  constructor(public activeModal: NgbActiveModal, private store: Store, private fb: UntypedFormBuilder, private feedbackService: FeedbackService, private utilityService: UtilityService, private eventsService: EventsService) { }


  ngOnInit() {
    this.store.select<User>('user').subscribe(user => {
      if (user) {
        this.user = user;
      }
    });
    this.store.select('activation').subscribe((activation: any) => {
      if(activation && activation[0]) {
        this.activation = activation[0];
      }
    });
    if (this.updateData) {
      this.mode = 'old';
    }
  }

  close() {
    this.activeModal.close();
  }

  ifChecked() {
    let hasAnswer = false;
    this.categoryOptions.forEach(opt => {
      if (opt.isSelected) {
        hasAnswer = true;
      }
    });
    if (hasAnswer) {
      this.showCommentBox = true;
    } else {
      this.showCommentBox = false;
    }
  }

  submitFeedback(e) {
    e.preventDefault();
    let payload = {
      courseId: this.data.courseId,
      courseName: this.data.courseName,
      comment: this.comment.trim(),
      category: this.categoryOptions.reduce((acc, category) => {
        category.isSelected && acc.push({ name: category.name, description: category.description });
        return acc;
      }, [])
    }
    if (this.data.contentType == 'video') {
      payload['videoId'] = this.data.videoId;
      payload['videoName'] = this.data.videoName;
      payload['videoTimeStamp'] = this.data.videoTimeStamp;
    } else {
      payload['exerciseId'] = this.data.exerciseId;
      payload['exerciseName'] = this.data.exerciseName;
      payload['questionId'] = this.data.questionId;
    }
    if (this.mode == 'new') {
      this.feedbackService.saveFeedback(payload).subscribe((res) => {
        this.feedbackResponse.emit(res['data']);
        this.amplitudeVedioFeedback();
        this.activeModal.dismiss();
        // event capture
        this.submitFeedbackEvent();
      });
    } else {
      this.feedbackService.updateFeedback(this.updateData._id, payload).subscribe((res) => {
        this.feedbackResponse.emit(res['data']);
        this.amplitudeVedioFeedback();
        this.activeModal.dismiss();
        // event capture
        this.submitFeedbackEvent();
      });
    }
    this.utilityService.updateEngagement('EntusiasticAdoption', 'ReportVideoFeedback', 2).subscribe();
  }

  amplitudeVedioFeedback() {
    /* amplitude.getInstance().init(config.AMPLITUDE_API_KEY);
    amplitude.getInstance().setUserId(this.user.email);
    amplitude.getInstance().setUserProperties({ 'name': this.user.name, 'organization': this.user.organization, 'cohortName': (this.user['userGroup'] || '') });
    amplitude.getInstance().logEvent('Give Feedback on Video', { 'Course Name': this.data.courseName, 'Exercise Name': this.data.exerciseName, 'Question Number': this.data.questionNumber }); */
  }

  submitFeedbackEvent(){
    try {   
      let errorType = '';
      for(let i=0; i<this.categoryOptions.length; i++){
        if(this.categoryOptions[i].isSelected){
          errorType = this.categoryOptions[i].name + ' , ' + errorType ;
        }
      }
      if(this.user && errorType && this.comment && this.activation && this.data){
        let eventData = { user: this.user, eType: errorType, activationData: this.activation, course: this.data, details: this.comment}
        this.eventsService.submitReportErrorEvent(eventData);
      }
    } catch (err) {
      console.log(err);  
    }
  }
}
